const Showroom = {
  parts: [
    'container',
    'content',
    'leftSection',
    'rightSection',
    'heading',
    'locationText',
    'primaryButton',
    'secondaryButton'
  ],
  baseStyle: {
    container: {
      color: 'white',
      display: 'flex',
      minHeight: {base: 'auto', lg: '652px'},
      justifyContent: 'center',
      alignItems: {base: 'center', lg: 'flex-start'},
      alignSelf: 'stretch',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      width: 'full',
    },
    content: {
      width: 'full',
      maxWidth: {base: 'full', lg: '1440px'},
      pt: {base: 16, md: 20, lg: 25},
      pr: {base: 5, md: 10, lg: 20},
      pb: {base: 10, md: 15, lg: 25},
      pl: {base: 5, md: 10, lg: 20},
      display: 'flex',
      flexDirection: {base: 'column', md: 'row'},
      justifyContent: {base: 'center', md: 'space-between'},
      alignItems: {base: 'center', md: 'flex-start'},
      gap: {base: 30, md: 5, lg: 5},
    },
    leftSection: {
      width: {base: 'full', md: 'calc(100% - 420px)'},
      maxWidth: {base: 'full', lg: '510px'},
      py: {base: 0, md: 8, lg: 16},
      px: 0,
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 6, lg: 10},
      flex: '0 0 auto',
    },
    rightSection: {
      width: {base: 'full', md: '400px'},
      flex: '0 0 auto',
      display: 'flex',
      alignItems: 'flex-start',
    },
    heading: {
      alignSelf: 'stretch',
      color: 'white',
      fontFamily: 'heading',
      fontSize: {base: '32px', md: '40px', lg: '6xl'},
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '120%',
      letterSpacing: {base: '-0.0275rem', lg: '-0.04rem'},
      position: 'relative',
      width: {base: 'full', lg: 'auto'},
    },
    locationText: {
      color: 'white',
      fontFamily: 'body',
      fontSize: 'sm',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: {base: 'normal', lg: '120%'},
      letterSpacing: {base: '0.009375rem', lg: '0px'},
      position: 'relative',
    },
    primaryButton: {
      display: 'flex',
      height: 13.5,
      py: 3.5,
      px: 12,
      justifyContent: 'center',
      alignItems: 'center',
      gap: 1.5,
      alignSelf: {base: 'stretch', lg: 'auto'},
      borderRadius: 'sm',
      backgroundColor: 'white',
      color: '#1B1A18',
      fontFamily: 'body',
      fontSize: 'sm',
      fontStyle: 'normal',
      fontWeight: 'semibold',
      lineHeight: '120%',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
      _hover: {
        background: 'whiteAlpha.900',
        transform: 'translateY(-1px)',
      },
      _active: {
        transform: 'translateY(0px)',
      },
    },
    secondaryButton: {
      display: 'flex',
      height: 13.5,
      py: 3.5,
      px: 12,
      justifyContent: 'center',
      alignItems: 'center',
      gap: 1.5,
      alignSelf: {base: 'stretch', lg: 'auto'},
      borderRadius: 'sm',
      border: '1px solid white',
      background: 'transparent',
      color: 'white',
      fontFamily: 'body',
      fontSize: 'sm',
      fontStyle: 'normal',
      fontWeight: 'semibold',
      lineHeight: '120%',
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
      _hover: {
        background: 'whiteAlpha.250',
        borderColor: 'whiteAlpha.800',
      },
      _active: {
        background: 'whiteAlpha.150',
      },
    },
  },
};

export default Showroom;
